export default __webpack_public_path__ + "static/hp-brand-deck-08-445b0c153691989e5590347a8d023ac4.png";